import BaseModel from '../core/BaseModel'
export default class ProductSerialNumberLogViewModel extends BaseModel {
    constructor() {
        super({ 
                name: "view_product_serial_number_info_history_detail",
                tableName: 'view_product_serial_number_info_history_detail'
            }, 
            {
                log_id: { 
                    name: 'log_id', 
                    type: "String", 
                    label: 'ID', 
                    primaryKey: true,
                    display: false
                },
                log_modified_date: { 
                    name: 'log_modified_date', 
                    type: "CustomDateTime", 
                    label: 'Thời gian cập nhật',
                    class: 'center',
                },
                
    
                full_name: { 
                    name: 'full_name', 
                    type: "String", 
                    label: 'Người cập nhật',
                    class: 'center'
                },
                organization_name: { 
                    name: 'organization_name', 
                    label: 'Đơn vị cập nhật',
                    class: 'center',
                    type: "String"
                },
                message: { 
                    name: 'message', 
                    type: "String",
                    label: 'Nội dung cập nhật',
                    computed: (data) => {
                        if (data.log_new_value != undefined && data.log_new_value != null && data.log_new_value != '') {
                            var decode = JSON.parse(data.log_new_value);
                            data.message = (decode.message != undefined && decode.message != null) ? decode.message : '';
                        }
                    }
                },
                verify_status: { 
                    name: 'verify_status', 
                    type: "Selection",
                    label: 'Trạng thái nghiệm thu',
                    dataType: 'Label',
                    class: 'center',
                    options: [{ value: 1, label: 'Đã nghiệm thu'}, { value: 0, label: 'Chờ nghiệm thu'}, { value: 2, label: 'Không nghiệm thu'}],
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals'},
                    computed: (data) => {
                        if (data.log_new_value != undefined && data.log_new_value != null && data.log_new_value != '') {
                            var decode = JSON.parse(data.log_new_value);
                            data.verify_status = (decode.verify_status != undefined && decode.verify_status != null) ? decode.verify_status : '';
                        }
                    }
                },
                warranty_status: { 
                    name: 'warranty_status', 
                    type: "Selection",
                    label: 'Trạng thái bảo hành',
                    dataType: 'Label',
                    class: 'center',
                    options: [{ value: 0, label: 'Chưa kích hoạt'}, { value: 2, label: 'Chờ kích hoạt'}, { value: 3, label: 'Đã kích hoạt'}, { value: 4, label: 'Hết bảo hành'}, { value: 6, label: 'Sản phẩm huỷ'}],
                    filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                    computed: (data) => {
                        if (data.log_new_value != undefined && data.log_new_value != null && data.log_new_value != '') {
                            var decode = JSON.parse(data.log_new_value);
                            data.warranty_status = (decode.warranty_status != undefined && decode.warranty_status != null) ? (decode.warranty_status == 5 ? 0 : decode.warranty_status) : -1;
                        }
                    }
                },
                id: {
                    refs: 'customer_profile_id log_modifier_id log_new_value request_product_serial_id',
                    display: false
                }
        },)
    }

}